import { render, staticRenderFns } from "./DirectoryModalForm.vue?vue&type=template&id=a9a35670"
import script from "./DirectoryModalForm.vue?vue&type=script&lang=js"
export * from "./DirectoryModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports